import { render, staticRenderFns } from "./SendMessagePopup.vue?vue&type=template&id=5c6099e8&"
import script from "./SendMessagePopup.vue?vue&type=script&lang=ts&"
export * from "./SendMessagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./SendMessagePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports